<script>
const axios = require("axios");
export default {
    name: "MagazineView",
    data(){
        return{
            api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
            months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            year: 0,
            month: "",
            pdfLocation: "",
            no_magazine_data: false,
        }
    },
    mounted() {
        const date = new Date();
        this.year = date.getFullYear();
        this.month = this.months[date.getMonth()];
        //console.info("Valor de año "+this.year);
        //console.info("Valor de mes "+this.month);

        this.getCurrentPdf();
    },
    methods: {
        closeMagazine: function(){
            //console.log('retorna');
            this.$router.push({
                name: 'magazine',
                params: { active: true },
            });
        },
        setupViewer: function(){
            var pdf = this.pdfLocation;
            var options = {
                height: '100%',
                webgl : false,
                webglShadow : false,
                scrollWheel : false,
                backgroundcolor : 'ghostwhite',
                overwritePDFOutline: false,
                hideControls: "download, pageMode, outline",
                enableAnnotation: false,
                enableDownload: false,
                pageMode: DFLIP.PAGE_MODE.AUTO,
                pixelRatio: window.devicePixelRatio || 1,
                pageSize: DFLIP.PAGE_SIZE.AUTO
            };
            var flipBook = $("#homeMagazineViewer").flipBook(pdf, options);
        },
        getCurrentPdf(){
            var pdf_url = this.api_url+"/subscriber/"+$cookies.get('uidmmkg')+"/magazine/"+this.year+"/"+this.month+"/1";
            axios({
                method: 'GET',
                url: pdf_url,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer "+$cookies.get('ctoken'),
                }
            }).then( (response) =>{
                //console.info("Respuesta de petición de PDF");
                //console.info(response);
                if (response.data.status){
                    this.pdfLocation = response.data.magazine.magazine_url;
                    if(this.pdfLocation === undefined){
                        //console.error("No hay revista");
                        this.no_magazine_data = true;
                    }else{
                        //console.log('pdf obtenido: ', this.pdfLocation);
                        this.setupViewer();
                        this.no_magazine_data = false;
                    }
                    // creacion de atributos para dificultar descarga de pdf
                    //this.pdfLocation = this.pdfLocation + btoa(this.pdfLocation);
                    //this.pdfLocation = this.pdfLocation.replace("https://mmkgroup-staging-domains-mmkgroupstagingdevadminm", "security-domain")
                    /*for (let i = 0; i < 21; i++) {
                        document.querySelector(".home-viewer").setAttribute("source"+i, this.pdfLocation);
                    }*/
                }else {
                    this.no_magazine_data = true;
                }
            }).catch( (error) => {
                //console.error(error);
                this.no_magazine_data = true;
            });
        },
    },
    filters: {
        formatUrlPdf: function(value){
            value = value + Math.random();
        }
    }
}
</script>

<template>
    <div>
        <div id="magazine-view-container" v-if="!no_magazine_data">
            <div oncontextmenu="return false" :data="pdfLocation" :sources="pdfLocation" :location="pdfLocation" class="home-viewer" :source="pdfLocation | formatUrlPdf">
                <div class="container-fluid home-viewer pt-0">
                    <div class="div">
                        <div class="row mx-auto">
                            <div class="col-12" style="padding-bottom:30px; height:100vh;">
                                <button type="button" class="close closeMagazine" @click="closeMagazine" aria-label="Close">
                                    <span class="closeMagazine" aria-hidden="true">&times;</span>
                                </button>
                                <!--FLipbook-->
                                <div class="_df_book" id="homeMagazineViewer"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- home-viewer -->
        </div>
        <div v-else>
            <h3 class="my-4 text-info">Estamos trabajando tu revista ...</h3>
        </div>
    </div>
</template>

<style lang="scss">
/* Portrait */
@media screen and (orientation:portrait) {
    #magazine-view-container{
        position: relative;
        width: 100%;
        height: 1200px;
    }
    .home-viewer {
        width: 100%;
        height: 1200px;
        position: absolute;
        background-color: ghostwhite;
        margin: 0;
        padding: 1% 0;
        top: 0;
        z-index: 10000000000;
        overflow: hidden;
    }
}
/* Landscape */
@media screen and (orientation:landscape) {
    #magazine-view-container{
        position: relative;
        width: 100%;
        height: 800px;
    }
    .home-viewer {
        width: 100%;
        height: 800px;
        position: absolute;
        background-color: ghostwhite;
        margin: 0;
        padding: 1% 0;
        top: 0;
        z-index: 10000000000;
        overflow: hidden;
    }
}
/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    #magazine-view-container{
        position: relative;
        width: 100%;
        height: 800px;
    }
    .home-viewer {
        width: 100%;
        height: 800px;
        position: absolute;
        background-color: ghostwhite;
        margin: 0;
        padding: 1% 0;
        top: 0;
        z-index: 10000000000;
        overflow: hidden;
    }
}
/* Desktops and laptops ----------- */
@media only screen and (min-width : 1224px) {
    #magazine-view-container{
        position: relative;
        width: 100%;
        height: 970px;
    }
    .home-viewer {
        width: 100%;
        height: 970px;
        position: absolute;
        background-color: ghostwhite;
        margin: 0;
        padding: 1% 0;
        top: 0;
        z-index: 10000000000;
        overflow: hidden;
    }
}

.close{
    position: absolute;
    top: 1%;
    right: 2%;
    font-size: 1.8vw;
    z-index:100;
}
.close.closeMagazine {
    opacity: 1;
}
.df-floating .df-ui-controls {
    bottom: 15px;
    box-shadow: 0px 0px 10px gray;
}
span.closeMagazine{
    color:#ea1a46;
}
[class^="ti-"]:before, [class*=" ti-"]:before {
    font-weight: normal;
    color:#ea1a46;
}
.df-ui-page label {
    color: black !important;
}
.df-ui-wrapper, .df-ui-btn {
    color: black !important;
    font-weight: 500;
}
.df-container .loading-info {
    margin-top: 40px;
    background-color: #fdfdfd4d;
    border-radius: 0px;
    font-size: 12px;
    font-weight: 900;
    color: #0a1527;
    left: 50%;
}
.df-container.df-loading:after {
    background-size: 100%;
    background-position: center;
}
.df-container:before, .df-container:after {
    height: 100px;
    width: 150px;
    left: 50%;
    top: 50%;
    margin: auto;
    transform: translate(-50%, -78%);
}
div[source]{
    color:transparent;
}
</style>